import { render, staticRenderFns } from "./OrderPieChart.vue?vue&type=template&id=059a6060&"
import script from "./OrderPieChart.vue?vue&type=script&lang=js&"
export * from "./OrderPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports